const BASE_URL = process.env.REACT_APP_API_URL;

export const createBackupDump = async () => {
  const url = new URL('/api/backup/dump', BASE_URL || window.location.origin);
  const response = await fetch(url.href, { method: 'POST' });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `HTTP error ${response.status} al crear backup`);
  }
  return response.json();
};

export const getBackupList = async () => {
  const url = new URL('/api/backup/list', BASE_URL || window.location.origin);
  const response = await fetch(url.href);
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `HTTP error ${response.status} al obtener lista de backups`);
  }
  return response.json();
};
